import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Home from './components/Home';
import WhoWeAre from './components/WhoWeAre';
import WhatWeDo from './components/WhatWeDo';
import Contact from './components/Contact';
import ContactBanner from './components/ContactBanner';
import Footer from './components/Footer';
import Cutch from './components/Cutch';
import AcaciaPowder from './components/AcaciaPowder';
import QuebrachoTannins from './components/QuebrachoTannins';
import IndianKatha from './components/IndianKatha';
import Export from './components/Export'; // ✅ Added
import QualityAndSustainability from './components/QualityAndSustainability';
import MachineKatha from './components/MachineKatha';





function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<><Hero /><Home /><ContactBanner /></>} />
        <Route path="/who-we-are" element={<><WhoWeAre /><ContactBanner /></>} />
        <Route path="/what-we-do" element={<><WhatWeDo /><ContactBanner /></>} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/cutch" element={<><Cutch /><ContactBanner /></>} />
        <Route path="/acacia-powder" element={<><AcaciaPowder /><ContactBanner /></>} />
        <Route path="/quebracho-tannins" element={<><QuebrachoTannins /><ContactBanner /></>} />
        <Route path="/indian-katha" element={<><IndianKatha /><ContactBanner /></>} />
        <Route path="/machine-katha" element={<><MachineKatha /><ContactBanner /></>} />
        <Route path="/export" element={<><Export /><ContactBanner /></>} /> {/* ✅ Added */}
        <Route path="/quality-sustainability" element={<><QualityAndSustainability /><ContactBanner /></>} />
        <Route path="/quality-sustainability" element={<><QualityAndSustainability /><ContactBanner /></>} />
        <Route path="/royal-punjab" element={<div style={{padding:'40px'}}>Royal Punjab - Coming Soon</div>} />
        <Route path="/rice-bran-oil" element={<div style={{padding:'40px'}}>Rice Bran Oil - Coming Soon</div>} />
        <Route path="/wesderby-ethic" element={<div style={{padding:'40px'}}>Wesderby Ethic - Coming Soon</div>} />
        <Route path="/csr" element={<div style={{padding:'40px'}}>CSR - Coming Soon</div>} />
        <Route path="/careers" element={<div style={{padding:'40px'}}>Careers - Coming Soon</div>} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;